import Vue from 'vue'
import Vant from 'vant'


// WEBPACK FOOTER //
// ./src/vendor.js